import { getAllProjectSiteRecce } from '@api/services/site-recce.service';
import useDataQuery from '@hooks/use-data-query';

export const useSiteRecceListData = (clientInstallationId: string, projectInstallationId: string) => {
    const siteRecceListQuery = useDataQuery(['site-recces', clientInstallationId, projectInstallationId], () =>
        getAllProjectSiteRecce(clientInstallationId, projectInstallationId)
    );

    return {
        siteRecceList: siteRecceListQuery.data,
        isLoading: siteRecceListQuery.isLoading,
    };
};
